import { render, staticRenderFns } from "./setTableColumn.vue?vue&type=template&id=5459dedd&scoped=true&"
import script from "./setTableColumn.vue?vue&type=script&lang=js&"
export * from "./setTableColumn.vue?vue&type=script&lang=js&"
import style0 from "./setTableColumn.vue?vue&type=style&index=0&id=5459dedd&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5459dedd",
  null
  
)

export default component.exports